import { css } from '@emotion/react';
import { getColor } from '@atlassiansox/wpl-utils';

export const bodyStyle = css`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
`;

export const containerStyle = css`
  text-align: center;
`;

export const headerStyle = css`
  font-family: Charlie Display, sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: 0.3px;
  margin-bottom: 8px;
`;

export const linkStyle = css`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  color: ${getColor('b300')};
  text-decoration: none;
`;
